module.exports = __webpack_public_path__ + "img/rectangle5.756f09ac.png";